define('Store.Collection', [
    'Store.Model',
    'Backbone',
    'Singleton'
], function StoreCollection(
    Model,
    Backbone,
    Singleton
) {
    'use strict';

    return Backbone.Collection.extend({
        model: Model
    }, Singleton);
});
